import { GET_USER, GET_USER_BY_ID } from "../constants/index";

export const user = (state = { userlist: [], userbyid: {} }, action) => {
  switch (action.type) {
    case GET_USER:
      return { ...state, userlist: action.userlist };
    case GET_USER_BY_ID:
      return { ...state, userbyid: action.userbyid };
    default:
      return state;
  }
};
